/**
 * Created by Bart Decorte
 * Date: 2019-09-15
 * Time: 12:37
 */
import IndexPage from '../IndexPage';
import { modifierState } from '../../helpers/os';

export default class AppsIndex extends IndexPage {
  constructor() {
    super();
    this.bindKeys(this.keyBindings());
  }

  bindListeners() {
    super.bindListeners();
    $('.js-apps tr').on('click', (ev) => this.lRowClick(ev));
  }

  lRowClick(ev) {
    let cancel = ['a'];
    if (
      $(ev.target).is(cancel.join(', ')) ||
      $(ev.target).parents(cancel.join(', ')).length
    ) {
      return true;
    }

    let $elt =
      $(ev.target).get(0).tagName === 'TR'
        ? $(ev.target)
        : $(ev.target)
            .parents('tr')
            .first();
    const location = $elt
      .find('.js-row-click-action')
      .first()
      .attr('href');

    if (modifierState(ev)) {
      window.open(location, '_blank');
      return false;
    }

    window.location = location;
    return false;
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/pages/Apps/AppsIndex.js